var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c("TermsAndConditions", {
              attrs: {
                "open-modal": _vm.openModal,
                "orp-details": _vm.brpDetails
              },
              on: {
                "close-modal": function($event) {
                  return _vm.closeTermsAndConditions()
                }
              }
            }),
            _vm._v(" "),
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row success-message text-center m-b-20" },
                      [
                        _c("h1", { staticClass: "title md-title" }, [
                          _c("span", {
                            staticClass: "buyer-registration-welcome-message"
                          })
                        ]),
                        _vm._v(" "),
                        _vm.brpDetails.description
                          ? _c("p", { staticClass: "subtitle p-t-10 p-b-10" }, [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.brpDetails.description) +
                                  "\n      "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: _vm.$t("ORP_SUB_HEADER", {
                                applicantType: _vm.applicantType
                              }),
                              expression:
                                "$t('ORP_SUB_HEADER', { applicantType })"
                            }
                          ],
                          staticClass: "subtitle p-b-15"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("OpenRegistrationPageForm", {
                      attrs: { "orp-details": _vm.brpDetails },
                      on: {
                        "on-open-terms-and-conditions":
                          _vm.openTermsAndConditions
                      },
                      model: {
                        value: _vm.registrationForm,
                        callback: function($$v) {
                          _vm.registrationForm = $$v
                        },
                        expression: "registrationForm"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button p-t-15"
                      },
                      [
                        _c(
                          "SubmitButton",
                          { attrs: { pending: _vm.isPending } },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("ORP_REGISTER_BUTTON", {
                                    applicantType: _vm.applicantType
                                  })
                                ) +
                                "\n      "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "backend-error-fade" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showErrorMsg,
                                expression: "showErrorMsg"
                              }
                            ],
                            staticClass: "text-center p-t-5"
                          },
                          [
                            _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.actionStatus.error !== ""
                                      ? _vm.actionStatus.error
                                      : _vm.$t("ORP_GENERIC_ERROR", {
                                          applicantType: _vm.applicantType
                                        })
                                  ) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("i18n", {
                          staticClass: "text-center p-t-15 prp_footer_contact",
                          attrs: { path: "ORP_FOOTER_CONTACT_EMAIL", tag: "p" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "applicantType",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.applicantType) +
                                        "\n        "
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "contactEmail",
                                fn: function() {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "home_link",
                                        attrs: {
                                          href:
                                            "mailto:" +
                                            _vm.brpDetails.contactEmail,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.brpDetails.contactEmail
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuccess
              ? _c("div", { staticClass: "success-message text-center" }, [
                  _c("h1", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "THANK_YOU",
                        expression: "'THANK_YOU'"
                      }
                    ],
                    staticClass: "title md-title"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: _vm.$t("ORP_THANK_YOU_LINE1", {
                          applicantType: _vm.applicantType
                        }),
                        expression:
                          "$t('ORP_THANK_YOU_LINE1', { applicantType })"
                      }
                    ],
                    staticClass: "subtitle"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "ORP_THANK_YOU_LINE2",
                        expression: "'ORP_THANK_YOU_LINE2'"
                      }
                    ],
                    staticClass: "subtitle"
                  })
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }